module.exports = __webpack_public_path__ + "496b55a230faf4845105d54a6c3e3f62.pdf";